"use client";

import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center">
        <div className="h-5 w-20 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/20 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground/70 hover:text-foreground hover:opacity-80 transition-opacity duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/abawithpassion",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/abawithpassion",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/abawithpassion",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com/abawithpassion",
    label: "Twitter"
  }];
  return <footer id="footer" className="w-full bg-background border-t border-border py-12">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col items-center gap-8">
          {}
          <div className="flex justify-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/aba_with_passion_footer_logo.png" alt="ABA With Passion Inc" className="h-7" />
          </div>

          {}
          <MenuProvider menu_id="29" className="w-full flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} data-index={i} newTab aria-label={social.label} className="flex items-center justify-center size-10 rounded-full bg-muted-light-background text-muted hover:bg-primary/10 hover:text-primary transition-all duration-[var(--duration-medium)]">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>

          {}
          <p className="text-sm text-muted text-center">
            © {currentYear} ABA With Passion Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}